import { getDatabase, ref, child, get, update } from "firebase/database";

/**
 * Get all switching from a champ
 * @param {String} champId 
 * @returns Array of switching
 */
const getSwitchingsFromChamp = async (champId) => {

    const dbRef = ref(getDatabase());
    let snapshot = await get(child(dbRef, `champs/${champId}/switching`))
    if (snapshot.exists()) {

        let switchings = snapshot.val();

        /* Sort array by id */
        let switchingsArray = []
        for (var prop in switchings) {
            if (!switchings[prop].wasDeleted) {
                let localObj = switchings[prop];
                localObj['__key'] = prop;
                localObj['index'] = parseInt(prop, 10);
                switchingsArray.push(localObj);
            }
        };
        // Order by index
        switchingsArray.sort(function (a, b) { return (a.index > b.index) ? 1 : ((b.index > a.index) ? -1 : 0) });

        return switchingsArray;
    } else {
        return [];
    }
}

/**
 * Get a specific switching from a champ
 * @param {String} champId 
 * @param {String} switchingId 
 * @returns Switching obj
 */
const getASwitchingFromChamp = async (champId, switchingId) => {

    const dbRef = ref(getDatabase());
    let snapshot = await get(child(dbRef, `champs/${champId}/switching/${switchingId}`))
    if (!snapshot.exists()) return null;

    return snapshot.val();
}

/**
 * Update a switching from a champ
 * @param {String} champId 
 * @param {String} switchingId
 * @param {Object} switchingToUpdate
 */
const updateASwitchingFromChamp = async (champId, switchingId, switchingToUpdate) => {

    const dbRef = ref(getDatabase());
    await update(child(dbRef, '/champs/' + champId + '/switching/' + switchingId), switchingToUpdate);
}

/**
 * Get all rotations from a champ
 * @param {String} champId 
 * @returns Array of rotations
 */
const getRotationsFromChamp = async (champId) => {

    const dbRef = ref(getDatabase());
    let snapshot = await get(child(dbRef, `champs/${champId}/rotation`))
    if (snapshot.exists()) {

        let rotations = snapshot.val();

        /* Sort array by id */
        let rotationsArray = []
        for (var prop in rotations) {
            if (!rotations[prop].wasDeleted) {
                let localObj = rotations[prop];
                localObj['__key'] = prop;
                localObj['index'] = parseInt(prop, 10);
                rotationsArray.push(localObj);
            }
        };
        // Order by index
        rotationsArray.sort(function (a, b) { return (a.index > b.index) ? 1 : ((b.index > a.index) ? -1 : 0) });

        return rotationsArray;
    } else {
        return [];
    }
}

/**
 * Get a specific rotation from a champ
 * @param {String} champId 
 * @param {String} rotationId 
 * @returns Rotation obj
 */
const getARotationFromChamp = async (champId, rotationId) => {

    const dbRef = ref(getDatabase());
    let snapshot = await get(child(dbRef, `champs/${champId}/rotation/${rotationId}`))
    if (!snapshot.exists()) return null;

    return snapshot.val();
}

/**
 * Update a rotation from a champ
 * @param {String} champId 
 * @param {String} rotationId
 * @param {Object} rotationToUpdate
 */
const updateARotationFromChamp = async (champId, rotationId, rotationToUpdate) => {

    const dbRef = ref(getDatabase());
    await update(child(dbRef, '/champs/' + champId + '/rotation/' + rotationId), rotationToUpdate);
}

export {
    getSwitchingsFromChamp,
    getASwitchingFromChamp,
    updateASwitchingFromChamp,
    getRotationsFromChamp,
    getARotationFromChamp,
    updateARotationFromChamp
}